<template>
  <v-container fluid>
  <v-flex class="pa-3">
    <v-card>
      <v-col cols="12" sm="6" md="4">
        Rake Link
      </v-col>
    </v-card>
    <v-row>
    <v-col cols="6">
    <div id="rakes" class="rake_container">
    <template v-for="(rake,index) in rakes" class="draggable-element">
      <v-card class="my-4" :key="rake.id">
        <v-system-bar
          color="cornflowerblue"
          :height="height"
          :lights-out="lightsOut"
          :window="window"
        >
          <v-icon>train</v-icon>
          <span>Link No {{ rake.name}}</span>
        </v-system-bar>
     <draggable
     :key="rake.id"
     :list="rake.trains"
     :id="rake.id"
     :scroll-sensitivity="200"
     :force-fallback="true"
     group="rake"
     animation="150"
     :multi-drag="true"
     selected-class="multi-drag"
     ghost-class="ghost"
     :move="moveChecker"
     @start="dragStart"
     @end="dragEnd"
     >
       <transition-group tag="div" class="grid" name="grid">
         <div slot="header" class="cell">
            <button slot="header">Add</button>
         </div>
         <div class="cell" :style ="train.props.style" v-for="(train, index) in rake.trains" :key="train.id">
           <div style="padding: 5px;">
           <div>{{train.data.org}}</div>
           <div>{{getFormattedTime(train.data.dep)}}</div>
           <div>{{train.data.train_no}}</div>
           <div>{{getFormattedTime(train.data.arr)}}</div>
           <div>{{train.data.dest}}</div>
         </div>
         </div>
       </transition-group>

     </draggable>
     </v-card>
     </template>
   </div>
 </v-col>
   <v-col cols="2">
     <div id="unlinked_trains" class="rake_container">
   <h3>Unlinked Trains</h3>

   <draggable :list="unlinked_trains" class="list-group" group="rake">
     <div
       class="list-group-item item"
       v-for="element in unlinked_trains"
       :key="element.train_no"
       :force-fallback="true"
     >
       {{ element.train_no }} {{ element.org }} {{getFormattedTime(element.dep)}} {{ element.dest }} {{getFormattedTime(element.arr)}}
     </div>

     <div
       slot="header"
       class="btn-group list-group-item"
       role="group"
       aria-label="Basic example"
     >
       <button class="btn btn-secondary" >Add</button>
       <button class="btn btn-secondary">Replace</button>
     </div>
   </draggable>
 </div>
</v-col>
<v-col cols="2">
{{rakes}}
</v-col>
<v-col cols="2">
 {{unlinked_trains}}
 </v-col>
</v-row>
 </v-flex>
</v-container>
</template>

<script>
import draggable from "vuedraggable";
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import {
  mapState,
  mapGetter,
  mapActions
} from 'vuex'

const cardColors = [
  'azure',
  'beige',
  'bisque',
  'blanchedalmond',
  'burlywood',
  'cornsilk',
  'gainsboro',
  'ghostwhite',
  'ivory',
  'khaki'
]
const pickColor = (train_no) => {
  const col = train_no % 2 == 0 ? 'lightsalmon' : 'lightblue'
  return col
}
export default {
  name: 'rake_link',
  components: {
      draggable,
  },
  data() {
    return {
      height: 30,
      lightsOut: false,
      window: false,
      rakes: {},
      search: '',
      valid: false,
      errors: [],
      train: {},
      train_loading: false,
      trains: [],
      unlinked_trains: [],
      isLoading: false,
      summary: {}
    }
  },
  computed: {
    ...mapState(['curDeviceId', 'curDeviceName', 'curTrainNo', 'curTrainDate', 'curOrg', 'curArr', 'curDest', 'curDep','curCrewId',
     'actDep', 'actArr','curStartDate','curEndDate',]),
  },


  created() {
    this.initialize()
  },

  methods: {
    ...mapActions(['updateCurDeviceId', 'updateCurDeviceName', 'updateCurTrainNo', 'updateCurTrainDate', 'updateCurOrg', 'updateCurCrewId',
     'updateCurArr', 'updateCurDest', 'updateCurDep', 'updateActDep', 'updateActArr','updateCurStartDate','updateCurEndDate']),
    initialize() {
      this.isLoading = true
      this.trains = []
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`${process.env.VUE_APP_API_URL}/rakelink/rakelink`)
        .then(response => {
        //  console.log(response);
          this.trains = response.data
          var rakewise_trains =_.groupBy( _.sortBy(response.data, 'dep'), 'rake_no')
        //    console.log(rakewise_trains)
            var rakes ={}
          _.forEach(rakewise_trains, function(value, key) {
        //       console.log(key);
               var rake = {
                 type: 'container',
                 id: value[0]['rake_no'],
                 name: value[0]['rake_no'],
                 props: {
                   orientation: 'vertical',
                   className: 'card-container'
                 },
                 trains: []
               }
               _.forEach(value, function(v, k) {
            //        console.log(k,v);
                    var train = {
                      type: 'draggable',
                      id: `${v['train_no']}`,
                      props: {
                        className: 'card',
                        style: {backgroundColor: pickColor(v['train_no']),fontSize: '12px'}
                      },
                      data: {
                        train_no: v['train_no'],
                        dep: v['dep'],
                        org: v['org'],
                        dest: v['dest'],
                        arr: v['arr']
                      }
                    }
                    rake.trains.push(train)
               });
               rakes[rake.id] = rake
          });
          this.rakes = rakes
          console.log(this.rakes)
          this.summary = this.getSummary(response.data)
          this.isLoading = false
        })
        .catch(e => {
          console.log(e)
          this.isLoading = false
        })

        axios.get(`${process.env.VUE_APP_API_URL}/rakelink/unlinked_trains`)
          .then(response => {
          //  console.log(response);
            this.unlinked_trains = response.data
          })
          .catch(e => {
            console.log(e)
            })
    },
    moveChecker() {

    },
    dragStart() {

    },
    dragEnd(evt) {
      console.log(evt)

    },

      //update traccar_db.device_train_map set dep = addtime(train_date, time(dep)), arr = addtime(train_date, time(arr));
    //update traccar_db.device_train_map set arr = adddate(arr, 1) where arr < dep;
  getFormattedDate(t) {
      if (t) {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
        var testDateUtc = moment.utc(lt);
        var localDate = moment(testDateUtc).local();
        return localDate.format("DD/MM/YYYY")
      } else {
        return '--'
      }
    },
    getFormattedTime(t) {
      if (t !== '--') {
       //  var lt = moment(t).format("YYYY-MM-DD HH:mm:ss")
       //  var testDateUtc = moment.utc(lt);
       // var localDate = moment(testDateUtc).local();
       //  return moment(localDate).format("HH:mm:ss")
       return moment(t,"HH:mm:ss").format("HH:mm")
      }
    },
    getFormattedTimeSec(t) {
      if (t < 0) {
        return '-' + moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      } else {
        return moment.utc(Math.abs(t) * 1000).format('HH:mm:ss')
      }
    },

    getColour(train) {
      if (train.act_arr) {
        let x = train.late_arr / 60
        switch (true) {
          case (x < 1):
            return 'green'
            break;
          case (x < 5):
            return '#6B8E23'
            break;
          case (x < 11):
            return 'blue'
            break;
          case (x < 21):
            return 'orange'
            break;
          case (x < 31):
            return '#FF1493'
            break;
          case (x < 1000):
            return 'red'
            break;
          default:
            return '#F5DEB3'
            break;
        }
      }
    },
    getSummaryColour(s) {
      return s == "more than 30" ? 'red' :
        s == "21 to 30" ? '#FF1493' :
        s == "11 to 20" ? 'orange' :
        s == "5 to 10" ? 'blue' :
        s == "less than 5" ? '#6B8E23' :
        s == "Right Time" ? 'green' :
        s == "total late" ? '#A52A2A' :
        s == "total train" ? '#D2691E' :
        s == "Puctuality" ? '#8A2BE2' :
        '#F5DEB3'
    },
    getSummary(trains) {
      let summary = {
        "Right Time": 0,
        "less than 5": 0,
        "5 to 10": 0,
        "11 to 20": 0,
        "21 to 30": 0,
        "more than 30": 0,
        "total late": 0,
        "total train": 0,
        "Puctuality": 0
      }
      _.forEach(trains, (train) => {
        if (train.act_arr) {
          let x = train.late_arr / 60
          switch (true) {
            case (x < 1):
              summary["Right Time"]++;
              summary["total train"]++;
              break;
            case (x < 5):
              summary["less than 5"]++;
              summary["Right Time"]++;
              summary["total train"]++;
              break;
            case (x < 11):
              summary["5 to 10"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 21):
              summary["11 to 20"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 31):
              summary["21 to 30"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            case (x < 1000):
              summary["more than 30"]++;
              summary["total late"]++;
              summary["total train"]++;
              break;
            default:
              break;
          }
        }
      })
      summary["Puctuality"] = Math.round((summary["Right Time"] / summary["total train"]) * 100, 2)
      return summary
    }
  }
}
</script>
<style>
/* .rake_container {
  max-height: 500px;
} */
.grid {
  display: grid;
  grid-template-columns: repeat(20, 80px);
  grid-template-rows: repeat(1, 100px);
  grid-gap: 0.2em;
}

.grid-move {
  transition: all 0.3s;
}

.cell {
  background-color: lightblue;
  display: flex;
  padding: 2em;
  justify-content: center;
  align-items: center;
}

td, th{
  padding: 5px !important;
}

h2{
  font-size: 1.3em;
  font-weight: 500;
}

p{
  margin: 0;
  font-size: 14px;
}

.v-toolbar__title{
  font-size: 1.2em;
}

.v-list__item__subtitle {
  font-size: 0.8em;
}

.v-list{
  border-bottom: 1px #f1f1f1 solid;
}

.inline{
  display: inline;
}

.button-section-space-between{
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.instructions-wrapper{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.chip-text{
  padding: 0;
  margin: 0;
  font-size: 14px;
  font-weight: 700;
}

.v-autocomplete{
  font-size: 13px;
  max-width: 150px;
}

.v-autocomplete-wrapper{
  display: flex;
  justify-content: center;
  height: 100%;
}

.list-group{
  cursor: grab;
}

.draggable-element{
  background-color: royalblue;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.multi-drag {
  opacity: 0.5;
  background-color: red;
}
</style>
